/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { SmtpSettings } from '@veeam-vspc/models/rest';

export const TestedSmtpSettingsContext = createContext<SmtpSettings>({} as SmtpSettings);
